var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"pageSatatus"},[_c('iframe',{ref:"iframeRef",attrs:{"src":_vm.iframeSrc,"frameborder":"0","allow":"clipboard-write"},on:{"load":_vm.onIframeLoad}})])])
}
var staticRenderFns = []

export { render, staticRenderFns }